/* tslint:disable */
 
import { EmbeddedPageConfig } from './embedded-page-config';
import { GenericViewAutoRefresh } from './generic-view-auto-refresh';
import { GenericViewComponent } from './generic-view-component';
import { GenericViewDisplayConfig } from './generic-view-display-config';
import { GenericViewGroup } from './generic-view-group';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { PageHelp } from './page-help';
import { RedirectionRuleRedirectConfig } from './redirection-rule-redirect-config';
import { SideBarConfig } from './side-bar-config';

/**
 * (tsType: Omit<GenericViewEndUserDto, >, schemaOptions: { includeRelations: false, title: 'GenericViewEndUserDto', exclude: [] })
 */
export class GenericViewEndUserDto {
  allowExportPDF?: boolean;
  autoRefresh?: null | GenericViewAutoRefresh;
  components?: Array<GenericViewComponent>;
  description?: null | NullableLocalizedValue;
  displayConfig?: null | GenericViewDisplayConfig;
  embeddedPageConfig?: null | EmbeddedPageConfig;
  groups?: Array<GenericViewGroup>;
  help?: null | PageHelp;
  icon?: null | Icon;
  id: string;
  name: LocalizedValue;
  pageType?: 0 | 1;
  redirection?: RedirectionRuleRedirectConfig;
  sideBarConfig?: null | SideBarConfig;
  uiAttributes?: null | {
};
}
